/* Fransk katalog for locale-payroll-runs-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'pay.salaryTypeSaved': 'Type de salaire enregistré.',
  'pay.salaryTypeSaveFailed': 'Impossible d\'enregistrer le type de salaire.',
  'pay.fixedLineSaved': 'Ligne de salaire fixe enregistrée.',
  'pay.fixedLineSaveFailed': 'Impossible d\'enregistrer la ligne de salaire fixe.',
  'pay.fillNameAndAccountNumber': 'Saisissez le nom et le numéro de compte.',
  'pay.accountAdded': 'Compte ajouté.',
  'pay.addAccountFailed': 'Impossible d\'ajouter le compte.',
  'pay.calculationCodeNotSupported': 'Ce code de calcul des cotisations patronales n\'est pas encore pris en charge. Choisissez « Secteurs généraux ».',
  'pay.payrollSettingsSaved': 'Paramètres de paie enregistrés.',
  'pay.payrollSettingsSavedWithRecalc': 'Paramètres de paie enregistrés. Brouillons de paie ouverts recalculés : {count}.',
  'pay.payrollSettingsSaveFailed': 'Impossible d\'enregistrer les paramètres de paie.',
  'pay.markedManualSubmission': 'Marqué comme dépôt manuel.',
  'pay.ameldingSentToAltinn': 'A-melding envoyée à Altinn.',
  'pay.payslipsCreatedAndPosted': 'Bulletins de paie créés et paie comptabilisée. Les bulletins peuvent être envoyés plus tard.',
  'pay.payrollRunEditableAgain': 'Le versement des salaires peut de nouveau être modifié.',
  'pay.accountingAnnulled': 'La comptabilisation a été annulée.',
  'pay.payrollRunAnnulled': 'Versement des salaires annulé.',
  'pay.payoutRegistered': 'Versement enregistré.',
  'pay.confirmAnnulPayment': 'Annuler ce paiement ? L\'écriture comptable est contrepassée, le paiement n\'étant plus pris en compte.',
  'pay.hideDeletedPayrollRuns': 'Masquer les versements supprimés',
  'pay.showDeletedPayrollRuns': 'Afficher les versements supprimés ({count})',
  'pay.removePermanently': 'Retirer définitivement',
  'pay.removeDeletedPayrollRunPermanently': 'Retirer définitivement le versement supprimé',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Retirer le versement supprimé ?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Cela retire définitivement le brouillon pour {period}. Seule une paie jamais approuvée, envoyée ou comptabilisée peut être retirée ici.',
  'pay.editPaymentTitle': 'Modifier le paiement',
  'pay.registerPaymentTitle': 'Enregistrer un paiement',
  'pay.savingEllipsis': 'Enregistrement...',
  'pay.savePaymentAction': 'Enregistrer le paiement',
  'pay.editSalaryTypeTitle': 'Modifier le type de salaire',
  'pay.newFixedLineTitle': 'Nouvelle ligne de salaire fixe',
  'pay.editFixedLineTitle': 'Modifier la ligne de salaire fixe',
  'pay.operatingAccount': 'Compte d\'exploitation',
  'pay.newWithholdingAccountTitle': 'Nouveau compte de retenue fiscale',
  'pay.newPayrollAccountTitle': 'Nouveau compte de salaires',
  'pay.addAccountAction': 'Ajouter un compte',
  'pay.totalPay': 'Salaire total',
  'pay.taxDeduction': 'Retenue fiscale',
  'pay.voucher': 'Justificatif',
  'pay.basis': 'Base',
  'pay.payrollRuns': 'Exécutions de paie',
  'pay.agaOfHolidayPayFull': 'Cotisations patronales sur congés payés',
  'pay.deadline': 'Échéance',
  'pay.paidAmount': 'Payé',
  'pay.remaining': 'Restant',
  'pay.provider': 'Fournisseur',
  'pay.orgNumber': 'N° d\'org.',
  'pay.earnedAtStandardRate': 'Acquis (10,2 %)',
  'pay.ameldingRegistered': 'A-melding enregistrée',
  'pay.noSubmissions': 'Aucune déclaration',
  'pay.posted': 'Comptabilisé',
  'pay.notPosted': 'Non comptabilisé',
  'pay.payslipsNotGenerated': 'Les bulletins de paie n\'ont pas été générés.',
  'pay.employmentSetOnEmployeePage': 'La relation de travail se définit sur la page du salarié',
  'pay.rulesFromSalaryType': 'Règles du type de salaire',
  'pay.useStandardRules': 'Utiliser les règles standard',
  'pay.advancedSettings': 'Paramètres avancés',
  'pay.overrideCanChangeCalculation': 'Un forçage peut modifier l\'impôt, les cotisations patronales, les congés payés, l\'OTP et la comptabilisation de cette ligne.',
  'pay.removeFromFixedLines': 'Retirer des lignes de salaire fixes',
  'pay.makeThisAFixedLine': 'En faire une ligne de salaire fixe',
  'pay.withholdingExceedsCashPayWarning': 'Le prélèvement à la source dépasse le salaire en espèces et les remboursements. Ajoutez du salaire en espèces ou réduisez le prélèvement avant de pouvoir approuver la paie.',
  'pay.attachDocumentationHint': 'Joignez des pièces au versement des salaires, par exemple des feuilles de temps ou des notes de frais manuelles.',
  'pay.upload': 'Téléverser',
  'pay.step1AltinnHelp': 'Une fois toutes les lignes incluses, l\'étape suivante consiste à déclarer le versement des salaires. L\'intégration Altinn sera connectée plus tard ; la déclaration peut donc être marquée comme dépôt manuel pour l\'instant.',
  'pay.step3PayslipsHelp': 'Une fois le versement déclaré et approuvé, les bulletins de paie sont créés et la paie est comptabilisée.',
  'pay.step4PaymentHelp': 'Enregistrez et comptabilisez le versement des salaires aux salariés et du prélèvement à la source à Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Le versement des salaires est finalisé une fois le paiement enregistré.',
  'pay.productionSupportedProfile': 'Profil pris en charge en production : paie norvégienne, période mensuelle, Secteurs généraux et cartes d\'imposition à pourcentage. Les cartes à barème, les codes spéciaux de cotisations patronales et le dépôt électronique sans accusé de réception sont bloqués.',
  'pay.searchMunicipalityOrNumber': 'Rechercher une commune ou un numéro',
  'pay.notSupportedYet': 'pas encore pris en charge',
  'pay.chooseGeneralIndustriesWarning': 'Choisissez « Secteurs généraux » avant de pouvoir enregistrer les paramètres. Le code de calcul choisi précédemment n\'est pas implémenté.',
  'pay.searchProvider': 'Rechercher un fournisseur',
  'pay.month.may': 'Mai',
  'pay.payTypeNotFixedLine': 'Ce type de salaire ne peut pas être utilisé comme ligne de salaire fixe.',
  'pay.calculationCodeUnsupportedShort': 'Ce code de calcul des cotisations patronales n\'est pas encore pris en charge.',
  'pay.overtimePay': 'Heures supplémentaires',
  'pay.mileageAllowance': 'Indemnité kilométrique',
  'pay.driveFallback': 'Trajet',
  'pay.taxableMileagePortion': 'Part imposable',
  'pay.expenseCategoryOther': 'Autre',
  'pay.overnightStayFallback': 'Nuitée',
  'pay.hotelFallback': 'Hôtel',
  'pay.mileagePayoutFallback': 'Indemnité kilométrique',
  'pay.ownCar': 'Véhicule personnel',
  'pay.travelPurposeFallback': 'Déplacement',
  'pay.taxTermWithholdingLabel': 'Prélèvement à la source {{date}}',
  'pay.taxTermAgaLabel': 'Période {{term}}',
  'pay.payrollRunNotEditableForNewLines': 'Une paie approuvée ne peut pas recevoir de nouvelles lignes de salaire.',
  'pay.payTypeNotManualEntry': 'Ce type de salaire ne peut pas être ajouté manuellement.',
  'pay.receiptInboxFallbackName': 'Justificatif de la boîte de réception',
  'pay.approvedButPayslipsFailed': 'La paie est comptabilisée, mais les bulletins de paie n\'ont pas été envoyés : {{error}}',
  'pay.recon.runLabelPeriod': 'Paie {{period}}',
  'pay.recon.runLabelRun': 'Exécution {{date}}',
  'pay.recon.notPaid': 'Non versé',
  'pay.recon.paidAfterPeriod': 'Versé après la date de période',
  'pay.recon.flag.negativ_netto': 'Salaire net négatif',
  'pay.recon.flag.mangler_skattekort': 'Carte d\'imposition manquante',
  'pay.recon.flag.sluttet_ansatt': 'Paiement à un ancien salarié',
  'pay.recon.flag.naturalytelse': 'Avantage en nature à vérifier',
  'pay.recon.flag.uvanlig_endring': 'Variation de salaire inhabituelle',
  'pay.recon.flag.mangler_amelding': 'Absent de l\'A-melding',
  'pay.recon.flag.mulig_duplikat': 'Double paiement possible',
  'pay.recon.flag.ikke_utbetalt': 'Non versé',
  'pay.recon.unknownEmployee': 'Salarié inconnu',
  'pay.recon.employmentTypeFixed': 'Permanent',
  'pay.recon.reported': 'Déclaré',
  'pay.recon.notReported': 'Non déclaré',
  'pay.recon.afterPeriodDate': 'Après la date de période',
  'pay.recon.role.forskuddstrekk': 'Prélèvement à la source de la période',
  'pay.recon.role.aga': 'Cotisations patronales calculées sur salaires',
  'pay.recon.role.aga_feriepenger': 'Cotisations patronales calculées sur congés payés',
  'pay.recon.role.feriepenger': 'Dette de congés payés selon le système de paie',
  'pay.recon.role.skyldig_lonn': 'Salaire net et retenues du système de paie',
  'pay.recon.role.pensjon': 'Cotisation retraite du système de paie',
  'pay.recon.row.brutto': 'Salaire brut',
  'pay.recon.row.naturalytelser': 'Avantages en nature imposables',
  'pay.recon.row.trekkpliktige': 'Prestations soumises à retenue',
  'pay.recon.row.godtgjorelser': 'Indemnités de frais',
  'pay.recon.row.aga_grunnlag': 'Assiette des cotisations patronales',
  'pay.recon.row.aga': 'Cotisations patronales calculées',
  'pay.recon.row.netto': 'Salaire net',
  'pay.recon.row.andre_trekk': 'Autres retenues',
  'pay.recon.row.feriepenger': 'Congés payés acquis',
  'pay.recon.row.pensjon': 'Cotisation retraite',
  'pay.recon.source.payrollSystem': 'Système de paie',
  'pay.recon.source.bankPayouts': 'Versements bancaires',
  'pay.recon.source.pensionBasis': 'Base de retraite',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} exécution comptabilisée sur la période',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} exécutions comptabilisées sur la période',
  'pay.recon.source.payrollSystemDetailEmpty': 'Aucune paie comptabilisée sur la période',
  'pay.recon.source.ledgerDetail': '{{count}} écritures sur les comptes de salaires',
  'pay.recon.source.ledgerDetailEmpty': 'Aucune écriture sur les comptes ajoutés au domaine de la paie',
  'pay.recon.source.ameldingDetailNone': 'Aucune exécution à déclarer',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} exécutions sur {{total}} sont enregistrées comme déclarées',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} exécutions sur {{total}} ne sont pas enregistrées comme déclarées',
  'pay.recon.source.bankDetailNone': 'Aucune exécution à payer',
  'pay.recon.source.bankDetailPaid': '{{paid}} exécutions sur {{total}} sont enregistrées comme versées',
  'pay.recon.source.pensionDetailPresent': 'Cotisation retraite calculée par le système de paie',
  'pay.recon.source.pensionDetailNone': 'Aucune cotisation retraite sur la période',
  'pay.recon.check.bokfort': 'Toutes les paies sont comptabilisées',
  'pay.recon.check.hovedbok': 'Le système de paie concorde avec le grand livre',
  'pay.recon.check.kontrollkontoer': 'Les comptes de contrôle concordent avec la base',
  'pay.recon.check.bank': 'Le salaire net a été versé',
  'pay.recon.check.amelding': 'L\'A-melding est enregistrée comme transmise',
  'pay.recon.check.skattekort': 'Tous les salariés ont une carte fiscale valide',
  'pay.recon.check.negativ': 'Aucun montant net négatif',
  'pay.recon.check.duplikat': 'Les paiements en double possibles sont identifiés',
  'pay.recon.check.uvanlig': 'Les variations de salaire inhabituelles sont identifiées',
  'pay.recon.check.sluttet': 'Les paiements aux salariés partis sont identifiés',
  'pay.recon.check.naturalytelse': 'Les avantages en nature sont analysés',
  'pay.recon.check.feriepenger': 'La dette d\'indemnité de congés payés est rapprochée',
  'pay.recon.check.termin': 'Le prélèvement à la source et les cotisations patronales sont réglés',
  'pay.creatingRun': 'Création…',
  'pay.pensionPremiumAmount': 'Prime de retraite réelle',
  'pay.pensionBankAmount': 'Payé depuis la banque',
  'pay.pensionFeeAmount': 'Frais distincts (brut)',
  'pay.pensionFeeVat': 'TVA sur les frais',
  'pay.pensionFeeAccount': 'Compte de charges pour les frais',
  'pay.pensionOverpaymentNotice': 'La différence est comptabilisée comme avance au prestataire de retraite sur le compte 1570.',
  'pay.createLaterCorrection': 'Créer une correction sur une période ultérieure',
  'pay.createCorrection': 'Créer une correction',
  'pay.laterCorrectionHelp': 'Le traitement d\'origine est conservé. Lorsque la correction est approuvée, seule la différence est comptabilisée sur la nouvelle période.',
  'pay.correctionCreated': 'Le traitement de correction a été créé en brouillon.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Personnalisé',
  'pay.statusInactive': 'Inactif',
  'pay.ruleTag.aga': 'AGA',
  'pay.ruleTag.tax': 'Impôt',
  'pay.ruleTag.holiday': 'Congés',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Soumis aux cotisations patronales',
  'pay.ruleTitle.tax': 'Soumis au prélèvement à la source',
  'pay.ruleTitle.holiday': 'Base de l\'indemnité de congés payés',
  'pay.ruleTitle.pension': 'Base de retraite',
  'pay.stdType.monthly-salary': 'Salaire fixe',
  'pay.stdType.hourly': 'Salaire horaire - hors heures supplémentaires',
  'pay.stdType.overtime-hourly': 'Salaire horaire - heures supplémentaires',
  'pay.stdType.commission-pay': 'Honoraires, travail à la pièce, pourcentage ou commissions',
  'pay.stdType.bonus-holiday-pay': 'Prime, ouvrant droit aux congés payés',
  'pay.stdType.bonus-no-holiday-pay': 'Prime, n\'ouvrant pas droit aux congés payés',
  'pay.stdType.board-fee': 'Jetons de présence',
  'pay.stdType.company-car': 'Véhicule de fonction',
  'pay.stdType.other-benefits': 'Autres avantages',
  'pay.stdType.taxable-insurance': 'Assurances, part imposable',
  'pay.stdType.car-km-allowance': 'Indemnités kilométriques',
  'pay.stdType.car-km-allowance-taxable': 'Indemnités kilométriques, part soumise au prélèvement',
  'pay.stdType.holiday-pay-current': 'Indemnité de congés payés acquise l\'année en cours',
  'pay.stdType.holiday-pay-previous': 'Indemnité de congés payés acquise les années précédentes',
  'pay.stdType.pension-premium': 'Prime de retraite OTP',
  'pay.stdType.canteen-deduction': 'Retenue cantine',
  'pay.stdType.holiday-deduction': 'Retenue sur salaire pour congés',
  'pay.stdType.extra-tax-deduction': 'Prélèvement fiscal supplémentaire',
  'pay.stdType.employee-expense-settlement': 'Remboursement de frais de déplacement',
  'pay.stdType.overnight-diet-hotel': 'Indemnité journalière avec nuitée',
});
